export function getAdminInfo () {
    const admin = localStorage.getItem('Admin')
    return admin ? JSON.parse(admin)[0] : {}
}